import { render } from "./LinksPage.vue?vue&type=template&id=5476196f&scoped=true&ts=true"
import script from "./LinksPage.vue?vue&type=script&lang=ts"
export * from "./LinksPage.vue?vue&type=script&lang=ts"

import "./LinksPage.vue?vue&type=style&index=0&id=5476196f&scoped=true&lang=css"

import exportComponent from "/builds/moneyspace/moneyspace_homepage_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5476196f"]])

export default __exports__